<template>
  <div>
    <div class="card">
      <div class="card-header">
<!--        Notas de Reembolso dos Clientes-->
        Reembolsos a Receber dos Clientes
      </div>
      <div class="card-body">
        <NRCustomersOpen></NRCustomersOpen>
<!--        <b-tabs>-->
<!--          <b-tab>-->
<!--            <template slot="title">-->
<!--&lt;!&ndash;              NR em aberto dos Clientes&nbsp;&ndash;&gt;-->
<!--              Em Aberto-->
<!--              <i class="fa fa-question-circle" style="color: #20a8d8" title="Notas que ainda não foram geradas."></i>-->
<!--            </template>-->

<!--          </b-tab>-->
<!--          <b-tab title="">-->
<!--            <template slot="title">-->
<!--&lt;!&ndash;              Todas Notas de Reembolso dos Clientes&nbsp;&ndash;&gt;-->
<!--              Todos os Reembolsos a Receber-->
<!--              <b-badge variant="danger" v-if="total">{{ total }}</b-badge>-->
<!--            </template>-->
<!--            <NRCustomersAll></NRCustomersAll>-->
<!--          </b-tab>-->
<!--        </b-tabs>-->
      </div>
    </div>
  </div>
</template>
<script>
import NRCustomersAll from './NRCustomersAll';
import NRCustomersOpen from './NRCustomersOpen';
import axios from 'axios';

export default {
  components: {
    NRCustomersAll,
    NRCustomersOpen,
  },
  data() {
    return {
      total: null
    }
  },
  mounted() {
    axios.get('/financial/refund-note/customers/no-paid/total/')
      .then(res => {
        this.total = res.data.total;
      })
  }
}

</script>
